// extracted by mini-css-extract-plugin
export default {"afterPayModeSection":"T8-z","refreshPageWarning":"U8-z","redirectMessageText":"V8-z"};